import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import once from 'transmute/once';
export function getDataSyncFailingToSyncLink(appId, accountId, connectionId) {
  const portalId = PortalIdParser.get();
  return `/data-sync/${portalId}/app/${appId}/account/${accountId}/settings/object-view/health/${connectionId}/failing-to-sync`;
}

/**
 * @description Check if the current host is a QA environment */
export const isQA = once(() => enviro.isQa());